import React from "react";
import { Segmented } from "antd";
function KoSegmented(props) {
  return (
    <Segmented {...props} />
  );
}
export default KoSegmented;